import apiFetch from '../apiFetch'

export default function (idTipoMaquina, token) {
  return apiFetch({endPoint: `Combos/getComboMaquinaActiva?idTipoMaquina=` + idTipoMaquina, method: 'GET', body: null, token: token})
}
